<template>
  <Application :uuid="uuid" @success="success" />
</template>

<script>
export default {
  props: ['uuid'],
  components: {
    Application: () => import('@/components/woori-crowd/Application.vue'),
  },
  created() {
    _meta({
      titles: ['우리동네크라우드', '상세', '참여신청서작성'],
    })
  },
  methods: {
    success() {
      // 상세페이지로 이동
      this.$router.replace({
        name: 'woori-crowd/detail',
        params: { uuid: this.uuid },
      })
    },
  },
}
</script>
